import {Component, Inject, OnInit, Optional} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import {ToastrService} from 'ngx-toastr';
import {Absence} from '../../_model/Absence';
import {AbsenceService} from '../../_services/absence.service';
import {DialogCloseData} from "../../_model/models";
import {DIALOG_OPERATIONS} from "../../_utils/constants";

@Component({
    selector: 'app-absence-delete',
    templateUrl: './absencedelete.component.html',
    styleUrls: ['./absencedelete.component.sass'],
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule
    ]
})
export class AbsenceDeleteComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<AbsenceDeleteComponent>,
                @Optional() @Inject(MAT_DIALOG_DATA) public data: Absence,
                private absenceService: AbsenceService,
                private toastr: ToastrService) { }

    ngOnInit() {
    }

    deleteAbsence(absence: Absence) {
        this.absenceService.deleteAbsence(absence).subscribe(result => {
            this.toastr.success('Silme işlemi başarılı', '');
            this.dialogRef.close(new DialogCloseData(DIALOG_OPERATIONS.DELETE , absence.id));
        }, error => {
            this.toastr.error(error.error.msg, 'Hata');
            this.dialogRef.close();
        });
    }

}
